import React from 'react';
import { Provider } from 'react-redux';
import { componentTypes } from '@white-nl/instantsearch-components';

import HierarchicalMenuComponent from '../../components/refinements/HierarchicalMenu';
import store from '../../redux-modules/store';
import { useGetCategoriesQuery } from '../../redux-modules/service';

type Category = {
  lft: number,
  slug: string,
  title: string,
  uri: string,
  children: Category[],
};

type CategoriesResponse = {
  categories?: Category[],
  entries?: Category[],
};

function HierarchicalMenu({
  results,
  menu,
  menuSettings,
  additionalData,
  createURL,
}: componentTypes.HierarchicalMenuPanelProps) {
  const { nodeUrl, siteId } = additionalData;

  const { data: categories } = useGetCategoriesQuery(
    { nodeUrl, siteId },
    { refetchOnMountOrArgChange: true },
  ) as { data: CategoriesResponse };

  const allCategories = [
    ...(categories?.categories || []),
    ...(categories?.entries || []),
  ];

  return (
    <HierarchicalMenuComponent
      results={results}
      menu={menu}
      menuSettings={menuSettings}
      additionalData={additionalData}
      createURL={createURL}
      categories={allCategories}
    />
  );
}

export default function HierarchicalMenuWithCategories({
  results,
  menu,
  menuSettings,
  additionalData,
  createURL,
}: componentTypes.HierarchicalMenuPanelProps) {
  return (
    <Provider store={store}>
      <HierarchicalMenu
        results={results}
        menu={menu}
        menuSettings={menuSettings}
        additionalData={additionalData}
        createURL={createURL}
      />
    </Provider>
  );
}
